import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization/localize";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const getCountryName = (
  countryISO: keyof typeof ISO3166Alpha3,
  strictLocalize: StrictLocalizeFunction
) => {
  return ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[
    countryISO as Exclude<
      keyof typeof ISO3166Alpha3,
      "ISO3166ALPHA3_UNKNOWN" | "CUB" | "PRK" | "SYR" | "IRN"
    >
  ];
};
